import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getPaymentTransactionListApi = (data, callback, errorCallBack) => {

  return async (dispatch) => {

    formDataCommonFunction(data, apiConstants.PAYMENT_GATEWAY.GET_PAYMENT_TRANSACTION_LIST)
      .then((response) => {
        callback && callback(response)

      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}